import React, { useEffect, useState } from "react";
import { Col, Row, Container } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import CircularProgress from "@material-ui/core/CircularProgress";
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem, SESSION_STORAGE_ESIGN_AUTH_KEY } from '../../../../../sessionStorage'
import IsJuvenile from '../../../../Helpers/Dates/IsJuvenile';

export default function Sign(props) {

  const { path } = useParams();
  const [iframeUrl, setIframeUrl] = useState("");

  const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;
  const isJuvenile = IsJuvenile(props.formState.pages.basicInfo.birthdate);
  let passcode = props.formState.pages.insuredInfo.socialSecurityNumber.replace(/-/g, '').substring(5);
  let birthdate = isJuvenile ? props.formState.pages.insuredInfo.ownerBirthdate : props.formState.pages.basicInfo.birthdate;
  let applicationID = props.formState.pages.consent.appIdentifier;

  useEffect(() => {

    // TODO when coming back from esign but formState still points to sign instead of status - routing can be improved
    if (path && path === 'status') {
      return;
    }

    const esignAuth = sessionStorage.getItem(SESSION_STORAGE_ESIGN_AUTH_KEY) && JSON.parse(sessionStorage.getItem(SESSION_STORAGE_ESIGN_AUTH_KEY));
    if (esignAuth) {
      passcode = esignAuth.passcode;
      birthdate = esignAuth.birthdate;
      applicationID = esignAuth.applicationID;
    }

    fetch(`${covrServicesUrl}/api/MinnSPWL/GetEsignIframeUrl?passcode=${passcode}&birthdate=${birthdate}&applicationID=${applicationID}`,
      {
        method: 'GET',
        headers: {
          'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId
        }
      })
      .then(res => res.json())
      .then(json => {
        setIframeUrl(json);
      })
  }, []);


  return (
    <Container>
      <Row>
        <Col>
          {iframeUrl &&
            <iframe src={iframeUrl} height="1000px" width="100%" scrolling="auto" frameBorder="0" title="Sign your application with Docusign" name='securian-wl-docusign' id='securian-wl-docusign'/>
          }

          {!iframeUrl &&
            <CircularProgress />
          }
        </Col>
      </Row>
    </Container>
  )
}

Sign.propTypes = {
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  formState: PropTypes.object.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Quoters/Securian/WL/steps/Sign.js